module.exports = __webpack_public_path__ + "img/pretakanje.31a80ecf.svg";